import { render, staticRenderFns } from "./CmgCountrySwitchAlertModal.vue?vue&type=template&id=3d0f6ad0&scoped=true&lang=pug"
import script from "./cmg-country-switch-alert-modal.ts?vue&type=script&lang=ts&external"
export * from "./cmg-country-switch-alert-modal.ts?vue&type=script&lang=ts&external"
import style0 from "./CmgCountrySwitchAlertModal.vue?vue&type=style&index=0&id=3d0f6ad0&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3d0f6ad0",
  null
  
)

export default component.exports